<template>
  <div lang="tr" class="vertical-align-step-0">
    <form method="POST" id="step1" @submit="sendForm" class="mb-4">
      <div
        @click="selectSecondaryProduct(product)"
        v-for="product in secondaryProducts"
        class="d-flex justify-content-between box-border gap-field"
        :key="product.id"
        v-bind:class="{
          'selected-product': selectedSecondaryProducts.includes(product.code),
        }"
      >
        <div class="vertical-center ml-1">
          <div>
            <h6 class="mb-1 font-weight-bold">{{ getProductName(product) }}</h6>
            <h6>
              ${{ Number(product.final_price) }}
              {{
                product.type === 'subscription'
                  ? product.period === 'annual'
                    ? '/ ' + $t('Yıl')
                    : '/ ' + $t('Ay')
                  : ''
              }}
            </h6>
          </div>
          <div>
            <p class="mb-0">{{ getProductDescription(product) }}</p>
          </div>
        </div>

        <div class="text-center vertical-center product-image">
          <img
            v-if="product.code === 'USTAX' || product.code === 'USTAXMONTHLY' || product.code === 'ABDGECMISAYLIK'"
            src="/img/company-types/us/mukellef-muhasebe.svg"
            class="company-type"
          />
          <img
            v-else-if="product.code === 'USEIN'"
            src="/img/company-types/us/ein-number.svg"
            class="company-type-default"
          />
          <img
            v-else-if="product.code === 'USITIN'"
            src="/img/company-types/us/itin-number.svg"
            class="company-type-default"
          />
          <img
            v-else-if="product.code === 'POSTCORPDOCS' || product.code === 'US Tax Residency Certificate'"
            src="/img/company-types/us/notary.svg"
            class="company-type-default"
          />
          <img
            v-else-if="product.code === 'USTAXRETURNSUB'"
            src="/img/company-types/us/tax-filing.svg"
            class="company-type-default"
          />
          <img v-else src="/img/company-types/us/default.svg" class="company-type-default" />
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import RegisterStore from '../../../stores/register';
import CompanyStore from '../../../stores/company';
import ProductStore from '@/stores/product';

export default {
  data() {
    return {
      products: [],
      secondaryProducts: [],
      selectedSecondaryProducts: [],
      main: ['STANDART_USPACKAGE', 'ADVANCE_USPACKAGE'],
      transferExceptions: [
        'USADDRESS',
        'USADDRESSMONTHLY',
        'USEXPRESSFORMATION_DELAWARE',
        'USEXPRESSFORMATION_WYOMING',
        'USEXPRESSFORMATION_TEKSAS',
        'USSTATEFEE_PAYMENT_COMMISSION',
        'USFRANCHISETAX_DELAWARE',
        'USFRANCHISETAX_WYOMING',
        'USFRANCHISETAX_TEKSAS',
        'USSTATEFEE_DELAWARE',
        'USSTATEFEE_WYOMING',
        'USSTATEFEE_TEKSAS',
        'STARTER_USPACKAGE',
        'USMEMBERSHIP_TAX_RETURN_FEE',
        'FLORIDAFORMATION',
        'GEORGIASTATEFEE',
      ],
      company: null,
      productType: 'annual',
    };
  },
  created() {
    this.startWaiting();
    CompanyStore.dispatch('getCompany').then((s) => {
      if (s.data.data.length) {
        this.company = s.data.data[0];

        if (this.$store.state.removePackageData) {
          this.company.package = [];
        }
        const products = [];

        if (this.company.package) {
          this.company.package.forEach(function myFunction(item, index) {
            if (!this.transferExceptions.includes(item)) {
              products.push(item);
            }
          }, this);
        }
        ProductStore.dispatch('getProductsByAddionalProduct', {
          companyId: this.company.id,
        }).then((s) => {
          this.products = s.data.data;
          this.filterProducts();

          if (this.company.package) {
            const matchingCodes = this.products
              .filter((product) => this.company.package.includes(product.code))
              .map((product) => product.code);

            this.selectedSecondaryProducts = matchingCodes;
          }

          this.endWaiting();
        });
      }
    });
  },
  methods: {
    selectSecondaryProduct(product) {
      if (this.selectedSecondaryProducts.includes(product.code)) {
        this.selectedSecondaryProducts.splice(this.selectedSecondaryProducts.indexOf(product.code), 1);
      } else {
        this.selectedSecondaryProducts.push(product.code);
      }
    },
    sendForm(callback) {
      let packageData = [];
      if (Array.isArray(this.company.package)) {
        packageData = [...this.company.package];
      }

      const removeArray = this.secondaryProducts.map((obj) => obj.code);

      packageData = packageData.filter((item) => !removeArray.includes(item));

      packageData = packageData.concat(this.selectedSecondaryProducts);
      if (!packageData.length) {
        this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
        return;
      }
      this.startWaiting();
      RegisterStore.dispatch('package', {
        packages: packageData,
        productType: this.productType,
      }).then((s) => {
        if (s.data.success === false) {
          this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
          this.endWaiting();
          return;
        }
        this.$store.commit('setremovePackageData', false);
        this.$store.commit('setCompanyId', s.data.data.id);
        callback();
      });
    },
    filterProducts() {
      this.secondaryProducts = this.products
        .filter(({ code }) => !this.transferExceptions.concat(this.main).includes(code))
        .filter(({ period, type }) => type === 'license' || period === this.productType)
        .sort(this.dynamicSort('order'));
    },
    dynamicSort(property) {
      let sortOrder = 1;
      if (property[0] === '-') {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function (a, b) {
        const firstValue = a[property];
        const secondValue = b[property];
        if (sortOrder === 1) {
          return (
            (firstValue === null) - (secondValue === null) || +(firstValue > secondValue) || -(firstValue < secondValue)
          );
        }
        return (
          (firstValue === null) - (secondValue === null) || -(firstValue > secondValue) || +(firstValue < secondValue)
        );
      };
    },
  },
};
</script>
<style scoped>
.features {
  font-size: 12px;
}

.vertical-center {
  margin-top: auto;
  margin-bottom: auto;
}

h3.main_question {
  font-size: 1rem;
}
</style>
